module.exports = __webpack_public_path__ + "img/banners.eb339e6d.png";